// Imports //

// Variables //

const navbarListEl = document.querySelector(".navbar__list"),
  navbarItemsEl = document.querySelectorAll(".navbar__item"),
  navbarToggleEl = document.querySelector(".navbar__toggle");

// Codes //

navbarToggleEl.addEventListener("click", () => {
  navbarListEl.classList.toggle("navbar__toggle--open");
});

if (navbarItemsEl.length > 0) {
  Array.from(navbarItemsEl).forEach((navbarItem) => {
    navbarItem.addEventListener("click", () => {
      navbarListEl.classList.toggle("navbar__toggle--open");
    });
  });
}

function copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(
    function () {
      alert("Copied to clipboard!");
    },
    function (err) {
      console.error("Could not copy text: ", err);
    }
  );
}

window.copyToClipboard = copyToClipboard;

// const filterFormSelectEls = document.querySelectorAll(".form--filter select");

// if (filterFormSelectEls.length !== 0) {
//   Array.from(filterFormSelectEls).forEach((filterFormSelectEl) => {
//     filterFormSelectEl.addEventListener("change", function () {
//       document.querySelector(".form--filter").submit();
//     });
//   });
// }

function printElement() {
  window.print();
}

// Exports //
